import { render, staticRenderFns } from "./EditorBtmOption.vue?vue&type=template&id=58ca89c7&scoped=true&"
import script from "./EditorBtmOption.vue?vue&type=script&lang=js&"
export * from "./EditorBtmOption.vue?vue&type=script&lang=js&"
import style0 from "./EditorBtmOption.vue?vue&type=style&index=0&id=58ca89c7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ca89c7",
  null
  
)

export default component.exports